export const CHANGE_PASSWORD_ACTION = 'CHANGE_PASSWORD_ACTION';
export const CHANGE_PASSWORD_SUCCESS_ACTION = 'CHANGE_PASSWORD_SUCCESS_ACTION';
export const CHANGE_PASSWORD_FAILURE_ACTION = 'CHANGE_PASSWORD_FAILURE_ACTION';
